const messages = {
  title: "Pood",
  description: "Tere tulemast premium-poodi. Siin saate lunastada oma Bridgestone Plusi punkte <br/> erinevate kategooriate preemiateks. Tootevalikut <br/> uuendatakse regulaarselt. Soovime teile palju lõbusat sirvimist.",
  sort: {
    asc: "Sorteeri: Madalaim hind",
    desc: "Sorteeri: Kõrgeim hind",
  },
  productSearchBox: {
    from: "punktid alates",
    to: "punktid kuni",
  },
  noProducts: "Otsingukriteeriumid ei andnud tulemusi",
  quantity: "Kogus",
  search: "Otsi",
  perPage: "Üksusi lehel",
  timeUnavailable: "Praegu pole saadaval",
  product: "Toode",
  cart: {
    pointsPerUnit: "Punktid ühiku kohta",
    pointsSum: "Punktide summa",
  },
  action: "Tegevus",
  pointsTotal: "Kokku",
  cartRemainPoints: "Ostukorvis järelejäänud punktid",
  shoppingCart: "Ostukorv",
  emptyCart: "Ostukorv on tühi.",
  attributes: "Atribuudid",
  selectAddressP: "Palun valige tarneaadress",
  orderDelivery: "Tarneaadress",
  selectedProducts: "Valitud tooted",
  orderSummary: "Tellimuse ülevaade",
  contactPerson: "Kontaktisik",
  selectedAddress: "Valitud aadress",
  order: {
    success: "Aitäh! Teie tellimus õnnestus. Saate mõne minuti pärast tellimuse kinnituse oma postkasti.",
    description: "Siit leiate ülevaate oma preemiapoe tellimustest.",
    info: "Siit leiate ülevaate oma preemiapoe tellimustest.",
    date: "Tellimuse kuupäev",
    number: "Tellimuse nr",
    status: {
      created: "Loodud",
      confirm_order: "Kinnita tellimus",
      ready_for_shipment: "Valmis saatmiseks",
      rejected: "Tagasi lükatud",
      processed: "Töödeldud",
      shipped: "Saadetud",
      returned: "Tagastatud",
      finished: "Lõpetatud",
    },
    anyOrder: "Tellimusi pole",
    products: "Tooted",
    quantity_short: "tk",
    itemRemoved: "ei ole tarnevalmis",
  },
  orders: "Tellimused",
  notEnoughPoints: "Teil pole piisavalt punkte.",
  statusText: "Olek",
  outOfStock: "Praegu laos pole",
  productUnavailable: "See toode pole enam saadaval.",
  deletedProductsTitle: "Tooted pole enam saadaval",
  deletedProductsMessage: "Järgmised tooted pole enam saadaval. Jätkamiseks eemaldage need ostukorvist.",
  removeSelected: "Eemalda valitud",
  clearCart: "Tühjenda ostukorv",
  removeSelectedConfirm: "Kas eemaldada valitud tooted ostukorvist?",
  clearCartConfirm: "Kas eemaldada kõik tooted ostukorvist?",
  incompleteAddress: {
    firstName: "Lisage tarneaadressile eesnimi",
    lastName: "Lisage tarneaadressile perekonnanimi",
    company: "Lisage tarneaadressile ettevõtte nimi",
    street: "Lisage tarneaadressile tänav ja maja number",
    postalCode: "Lisage tarneaadressile postiindeks",
    city: "Lisage tarneaadressile linn",
    country: "Lisage tarneaadressile riik",
    phone: "Lisage tarneaadressile telefoninumber",
  },
  placeOrder: "Siduv tellimus",
  toOrderDelivery: "Jätka tarneaadressile",
  toOrderSummary: "Tellimuse ülevaatesse",
  productImg: "Toote pilt",
  selectAddressBtn: "Vali aadress",
  perPgae: "Üksusi lehel",
  categories: {
    advertising: {
      title: "Reklaammaterjalid",
      desc: "Osalege otse siin platvormil ja kindlustage <br/> 40 lisapunkti preemiaklubile.",
    },
    rewards: {
      title: "Eksklusiivsed preemiad",
      desc: "Avastage boonuspakkumine meie koolituskeskuses või oma asukohas.",
    },
    tools: {
      title: "Töökoja tööriistad",
      desc: "Kasutage punkte kolmandate osapoolte koolitusteks <br/> ja vähendage kulusid.",
    },
    trainings: {
      title: "Koolitused ja kursused",
      desc: "Avastage boonuspakkumine meie koolituskeskuses või oma asukohas.",
    },
    salesroom: {
      title: "Müügiruum",
      desc: "Kujundage müügiruum ja pakkuge klientidele meeldivat viibimist.",
    },
    hunter: {
      title: "Hunter",
      desc: "Vahetage punkte Hunteri atraktiivse töökoja varustuse vastu.",
    },
  },
  bestSold: "Enimmüüdud",
  seasonal: "Hooajaline",
  affordable: "Peaaegu valmis",
  forPoints: "{points} punkti eest",
  reachedPoints: "Nõutud punktid saavutatud",
  remainingPoints: "Puudu {points} punkti",
  favoriteProducts: {
    description: "Siit leiate salvestatud tooted.",
  },
  categoryPageDescriptionFallback: "Materjal töökotta või muud kvaliteetsed tooted Bridgestone'i logoga teie ettevõttele",
  variant: "Valitavad variandid",
};
export default {
  messages,
};
